import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import TwoColumnText from 'components/projects/shared/TwoColumnText'

const ProjectWork = ({
  projectDescription,
  projectTitle,
  projectParagraphs,
  vertical,
  isCentered,
  titleTheme,
  hasNoTitle,
  hasSmallMarginTitle,
  hasSmallDescription,
}) => {
  return (
    <div className="project__section__container project__work__container">
      <div className="project__content__container">
        {!hasNoTitle && (
          <div
            className={cx('project__work__meta', {
              '--has-small-margin': hasSmallMarginTitle,
            })}
          >
            <div
              className={cx('project__section__title project__work__title', {
                [`--${titleTheme}`]: !!titleTheme,
              })}
            >
              Our Work
            </div>
          </div>
        )}
        <TwoColumnText
          paragraphs={projectParagraphs}
          description={projectDescription}
          title={projectTitle}
          vertical={vertical}
          isCentered={isCentered}
          hasSmallDescription={hasSmallDescription}
        />
      </div>
    </div>
  )
}

ProjectWork.defaultProps = {
  vertical: false,
}

ProjectWork.propTypes = {
  projectDescription: PropTypes.string,
  projectTitle: PropTypes.string,
  projectParagraphs: PropTypes.arrayOf(PropTypes.string),
  vertical: PropTypes.bool,
  hasSmallMarginTitle: PropTypes.bool,
  titleTheme: PropTypes.string,
  hasNoTitle: PropTypes.bool,
  isCentered: PropTypes.bool,
  hasSmallDescription: PropTypes.bool,
}

export default ProjectWork
